// extracted by mini-css-extract-plugin
module.exports = {"search-icon-wrapper":"_99551c8aa8--search-icon-wrapper--sfS1e"};